<template>
  <div style="min-height:70vh;padding: 10px">
    <!-- <Form
      :model="searchData"
      inline
      @submit.native.prevent="getData(1)"
      :label-width="100"
    >
    </Form> -->
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border style="margin: 10px 0">
      <template slot-scope="{row}" slot="address">
        <Poptip trigger="hover" transfer :content="row.address">
          <span>{{ row.address }}</span>
        </Poptip>
      </template>
      <template slot-scope="{row}" slot="express_no">
        <Poptip trigger="hover" transfer :content="row.express_no">
          <span>{{ row.express_no }}</span>
        </Poptip>
      </template>
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="status">
        {{ row.status == -1 ? '待支付' : row.status == 1 ? '待发货' : '已发货' }}
      </template>
    </Table>
    <Page style="text-align: right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  import { mapState } from "vuex";
  export default {
    computed: {
    },
    data() {
      return {
        searchData: {},
        tableColumns: [
          { title: "序号", slot: "index", width: 80, align: "center" },
          // { title: "ID", key: "id", align: "center",maxWidth:80 },
          { title: "订单号", key: "order_sn", align: "center", minWidth: 120, },
          { title: "商品名称", key: "product_name", align: "center", minWidth: 120, },
          { title: "购买数量", key: "count", align: "center", minWidth: 120, },
          { title: "积分总价", key: "total_integral", align: "center", minWidth: 120, },
          { title: "消费赠送积分", key: "given_integral", align: "center", minWidth: 120, },
          { title: "消费充值积分", key: "recharge_integral", align: "center", minWidth: 120, },
          { title: "状态", slot: "status", align: "center", minWidth: 120, },
          { title: "收货地址", slot: "address", align: "center", minWidth: 120, },
          { title: "快递公司", key: "express_company", align: "center", minWidth: 120, },
          { title: "快递单号", slot: "express_no", align: "center", minWidth: 120, },
        ],
        indexUrl: "/app/product_order/index",
      };
    },
    mixins: [indexPage],
    mounted() {
    },
    methods: {
    },
  };
</script>
<style scoped lang="less">
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
</style>
